import { Stack } from '@kinesis/bungle';
import { PendingInvitationRow } from './pending-invitation-row';
import { PendingShareRow } from './pending-share-row';
import { InvitationData } from '@/types';

const PendingInvitationList = (props: PendingInvitationListProps) => {
  const { onAccept, onDecline, invitations } = props;
  return (
    <Stack space='small'>
      {invitations.map((invitation) =>
        invitation.namespace === 'disclosure' ? (
          <PendingShareRow
            onAccept={onAccept}
            onDecline={onDecline}
            invitation={invitation}
          />
        ) : (
          <PendingInvitationRow
            onAccept={onAccept}
            onDecline={onDecline}
            invitation={invitation}
          />
        ),
      )}
    </Stack>
  );
};

export type PendingInvitationListProps = {
  onAccept?: (token: string) => void;
  onDecline?: (token: string) => void;
  invitations: InvitationData[];
};

export { PendingInvitationList };
